<template>
    <v-card v-if="journal_id != 3"
        class="mx-2"
        width="100%" tile
    >
        <v-system-bar :color="journal.color">
            <span class="text-subtitle-2 white--text">Full texts of older issues</span>
        </v-system-bar>
        <v-container fluid >
            <p>All full texts up to 24 months moving wall are available from the
                <v-btn v-if="width >490" class="ml-3 nottransform small"
                    :href="journal.dml"
                    target="_blanc">Czech Digital Mathematics Library
                    <v-img
                        :src="require('../../../assets/library/dmlczlogo.png')"
                        max-height="30"
                        max-width="120"
                        contain
                        class="ma-0"
                    ></v-img>
                </v-btn>
                <a v-else class="ml-3" href="http://www.emis.de/journals/MB/index.html"
                    target="_blanc"> Czech Digital Mathematics Library.
                    <img
                        src='../../../assets/library/dmlczlogo.png'
                        height="40"
                        class="ma-0"
                    ><img>
                </a>
            </p>
            <p>and from the
                <v-btn v-if="width >490" class="ml-3 nottransform small"
                :href="journal.eudml"
                target="_blanc">European Digital Mathematics Library
                    <v-img
                        :src="require('../../../assets/library/EUDMLlogo.png')"
                        max-height="30"
                        max-width="120"
                        contain
                        class="ma-0"
                    ></v-img>
                </v-btn>
                <a v-else class="ml-3" href="http://www.emis.de/journals/MB/index.html"
                    target="_blanc"> European Digital Mathematics Library.
                    <img
                        src='../../../assets/library/EUDMLlogo.png'
                        height="40"
                        class="ma-0"
                    ><img>
                </a>
            </p>
            <!-- <p v-if="journal_id == 3" >
                Full texts (1995-2008) are available from the.
                <v-btn v-if="width >490" class="ml-3 nottransform small" min-height="45"
                    href="http://www.emis.de/journals/MB/index.html"
                    target="_blanc">Electronic Library of Mathematics
                    <v-img
                        :src="require('../../../assets/library/EMISlogo.gif')"
                        max-height="45"
                        max-width="120"
                        contain
                        class="ma-0"
                    ></v-img>
                </v-btn>
                <a v-else class="ml-3" href="http://www.emis.de/journals/MB/index.html"
                    target="_blanc"> Electronic Library of Mathematics.
                    <img
                        src='../../../assets/library/EMISlogo.gif'
                        height="40"
                        class="ma-0"
                    ><img>
                </a>
            </p> -->
        </v-container>
</v-card>
</template>
<script>
import {mapGetters} from 'vuex';
import {mapActions} from 'vuex';
export default {
    data() {
        return {
            journal_id:null,
        }
    },
    created(){
        this.journal_id = this.$route.params.journal_id;
    },
    computed:{
        ...mapGetters('library',{
            journal:'journal',
        }),
        ...mapGetters('header',{
            width:'width',
        }),
    },
    methods:{
        ...mapActions('header',{
            set_width:'set_width',
        }),
        onResize(e) {
            const { scrollWidth, scrollHeight } = e;
            this.set_width(scrollWidth);
        }
    },
}
</script>
<style  scoped>
.nottransform{
    text-transform: none !important;
}
</style>
